import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, map, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SERVICE_URL } from '../../_urls/service.urls';
import { HttpService } from '../_http/http.service';

@Injectable({
    providedIn: 'root',
})
export class UserService {
    keyClockUrl = environment.keyClockApiBaseUrl + SERVICE_URL.KEYCLOCK_SERVICE;
    roleRequestUrl =
        environment.keyClockApiBaseUrl + SERVICE_URL.KEYCLOCK_SERVICE;
    private _tenantId = new BehaviorSubject<string | null>(null);
    private _activeRole = new BehaviorSubject<string | null>(null);

    constructor(
        private http: HttpClient,
        private httpService: HttpService
    ) {}

    getUserInfo() {
        const url = `${environment.keycloak.issuer}realms/${environment.keycloak.realm}/protocol/openid-connect/userinfo`;
        return this.http.get(url, { observe: 'response' }).pipe(
            map((response: any) => {
                return response.body;
            }),
            catchError((error) => {
                return throwError(error);
            })
        );
    }

    getUserProfileDetails(params: any) {
        const url = `${this.keyClockUrl}realms/${environment.keycloak.realm}/user`;
        return this.httpService.getRecords(url, params);
    }

    getUserAssignedRoles(id: any) {
        const url = `${this.keyClockUrl}realms/${environment.keycloak.realm}/users/${id}/role-mappings`;
        return this.httpService.getRecords(url);
    }

    deleteRoles(userId: string, clientId: string, roleId: string) {
        const url = `${this.keyClockUrl}realms/${environment.keycloak.realm}/users/${userId}/role-mappings/clients/${clientId}`;
        return this.httpService.deleteRecord(url, '', { id: roleId });
    }

    getUserRoles(client: string) {
        const url = this.keyClockUrl + 'store/lokos-roles/' + client;
        const query = `FROM keycloak.LokosRole where client = '${client}'`;
        return this.httpService.saveRecord(url, { query, max_results: 1000 });
    }

    assignRoles(userId: string, clientId: string, payload: any) {
        const url = `${this.keyClockUrl}realms/${environment.keycloak.realm}/users/${userId}/role-mappings/clients/${clientId}`;
        return this.httpService.saveRecord(url, payload);
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getUserCredentials(id: string) {
        const url = `${environment.keycloak.issuer}realms/${environment.keycloak.realm}/account/credentials`;
        return this.httpService.getRecords(url);
    }

    getUserProfileImage() {
        const url = `${this.keyClockUrl}realms/${environment.keycloak.realm}/image`;
        return this.httpService.getRecords(url, {}, 'text');
    }

    getUserProfile() {
        const url = `${this.keyClockUrl}userinfo`;
        return this.httpService.getRecords(url);
    }

    getAllClients() {
        const url = `${this.keyClockUrl}realms/${environment.keycloak.realm}/clients`;
        return this.httpService.getRecords(url);
    }

    submitRoleRequest(payload: any) {
        const url = `${this.roleRequestUrl}store/access-request`;
        return this.httpService.saveRecord(url, payload);
    }

    getUserRolesRequest(payload: any, params?: any) {
        return this.http.post(
            `${this.keyClockUrl}store/access-request/entries`,
            payload,
            { params }
        );
    }

    setTenantId(value: string) {
        this._tenantId.next(value);
    }

    getTenantId(): string | null {
        return this._tenantId.getValue();
    }

    setActiveRole(value: string) {
        this._activeRole.next(value);
    }

    getActiveRole(): string | null {
        return this._activeRole.getValue();
    }

    generateTenantId(stateShortCode: string) {
        if (!stateShortCode) {
            return 'dynamic_lokos';
        }
        return `dynamic_lokos_${stateShortCode}`;
    }
}
